<template>
  <v-container  grid-list-xs>  
    <v-row align="center" justify="center" class="mt-3">
      <v-col cols="12" lg="9" xl="9" class="text-justify">
        <v-row align="center" justify="center">
          <v-col cols="12" xl="8" lg="8" class="text-center">
            <h1> <p> Olimpiada Internacional de Química </p></h1>
          </v-col>
        </v-row>

        <h3> <p> El origen de organizar una Olimpiada Internacional de Química se dio en 1968 en la antigua Checoslovaquia. 
            Su objetivo, incrementar el número de contactos internacionales, así como intercambiar información entre las naciones.</p></h3>

        <h3><p> El Comité Nacional de Checoslovaquia fue el encargado de invitar a todos los países socialistas. Como en el 68 las relaciones entre 
        Checoslovaquia y la Unión Soviética se hicieron tensas, sólo Polonia y Hungría participaron en esa primera competencia internacional. 
        La primera Olimpiada en un país no socialista tuvo lugar en 1980 en Linz, Austria. El único año que no se llevó a cabo la competencia fue en 1971. </p></h3>

        <h3><p> México participó por primera vez en la XXIV Olimpiada Internacional de Química, celebrada en los Estados Unidos de América en julio de 1992, 
        desde entonces a la fecha, los estudiantes mexicanos han obtenido medallas de plata, de bronce y menciones honoríficas.</p></h3>

        <h3><p> Con la caída del muro y la desintegración de la Unión Soviética en estados independientes, a principios de 1990 aumentó el número de participantes,
          además de que se integraron a la competencia los países de Asia y de Latinoamérica. En la Olimpiada de 1998 se alcanzó la cifra de 47 delegaciones. En la 
          actualidad participan alrededor de 80 países en la Olimpiada Internacional de Química (IChO por sus siglas en inglés).</p></h3>

        <h3><p> Las Olimpiadas están programadas en los siguientes países: Georgia (2016), Tailandia (2017), República Checa y Eslovaquia (2018), 
            Francia (2019) y Japón (2021).</p></h3>

        <h3><p> La Olimpiada usualmente se celebra en julio de cada año. La delegación de cada país participante se compone de los competidores y acompañantes 
            (también conocidos como mentores). Hay cuatro competidores y dos mentores en la delegación. Por otra parte, los países pueden incluir dos observadores 
            como parte de su delegación. Los competidores no deben ser estudiantes universitarios y deben tener menos de 20 años de edad al 1 de julio del año de la 
            competencia. Los estudiantes dedican dos días completos a la competencia. El examen práctico generalmente se realiza en un laboratorio durante cinco horas. 
            El examen teórico también tiene esa duración.</p></h3>

        <h3><a href="https://www.icho2024.sa/" target="_blank"> Saber más</a></h3>

      </v-col>
    </v-row>
  </v-container>  
</template>

<script>
export default {
  metaInfo: {
    title: 'Olimpiada Internacional de Quimica',
    htmlAttrs: {
      lang: 'es',
      amp: true
    }
  },

}
</script>

<style>

</style>